export default "__VITE_ASSET__BQNlRhwU__"